const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const toSnakeKey = (key) => key.replace(/([A-Z])/g, "_$1").toLowerCase();

export function toSnakeCase(value) {
  if (Array.isArray(value)) {
    return value.map((item) => toSnakeCase(item));
  }
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        toSnakeKey(key),
        toSnakeCase(item),
      ])
    );
  }
  return value;
}

export function stringifySnake(value) {
  return JSON.stringify(toSnakeCase(value));
}
